import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { useState } from 'react';
import { FinanceDashboardMcoPbmTrendChart } from '../charts/FinanceDashboardMcoPbmTrendChart';

export const FinanceDashboardMcoPbmTrendCard = ({ startPeriod, endPeriod, periodicity, prodIds }) => {

  const [periodDim, setPeriodDim] = useState('PAID_PERIOD');

  return (
    <DashboardCard
      title="Managed Care Payments"
      buttons={
        <ToggleButtonGroup
          value={periodDim}
          exclusive
          size="small"
          onChange={(e, value) => {
            setPeriodDim(value);
          }}
        >
          <ToggleButton value="PAID_PERIOD">
            Paid Period
          </ToggleButton>
          <ToggleButton value="EARNED_PERIOD">
            Earned Period
          </ToggleButton>
        </ToggleButtonGroup>
      }
    >
      <FinanceDashboardMcoPbmTrendChart
        periodDim={periodDim}
        startPeriod={startPeriod}
        endPeriod={endPeriod}
        periodicity={periodicity}
        prodIds={prodIds}
      />
    </DashboardCard>
  )
}